import { CHAT_SEND, CHAT_HISTORY } from '@/utils/constants/api-endpoints'
import socket from '@/plugins/socket'

export const send = data => socket.request(CHAT_SEND, data)
export const history = room => socket.request(CHAT_HISTORY, room)
